import { restRequest } from 'core/utils/backend-service';
import { DeviceTypeTriggerCatalogue } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { RegisteredEventsByDeviceTypeApi } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.api';
import {
    DEVICE_TYPE_ENTITY,
    REGISTERED_EVENTS_SEARCH_ENDPOINT,
} from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.constants';
import { mapTriggerCatalogueFromApi } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-trigger-catalogue.mapper';

export const searchRegisteredEvents = (deviceTypeIds: string[]): Promise<DeviceTypeTriggerCatalogue[]> =>
    restRequest('POST', REGISTERED_EVENTS_SEARCH_ENDPOINT, {
        body: { type: DEVICE_TYPE_ENTITY, ids: deviceTypeIds },
    })
        .then((response) => response.json() as Promise<RegisteredEventsByDeviceTypeApi>)
        .then((eventsByDeviceType) => mapTriggerCatalogueFromApi(deviceTypeIds, eventsByDeviceType));
